import React from 'react'
import { PageHeader, BodyText } from '@reapit/elements'

const LoginFailedBlock: React.FC = () => {
  return (
    <div style={{ maxWidth: '800px', margin: 'auto', padding: '10px' }}>
      <PageHeader
        avatar={{
          src: 'error.png',
          type: 'image',
        }}
        hasMaxWidth
        pageTitle={{
          children: "Welcome! It looks like you're not a registered user...",
          hasBoldText: true,
        }}
      />
      
      <div style={{ marginTop: '20px' }}>
        <BodyText hasGreyText>
          To use Prospector Pro, please follow these steps to validate your email:
        </BodyText>
        
        <ul style={{ margin: '15px 0', paddingLeft: '20px' }}>
          <li>Click the extension icon in your browser's toolbar</li>
          <li>Find Prospector Pro plugin and select "Details"</li>
          <li>Select "Extension Options" </li>
          <li>Enter your Gluedog email address in the provided field</li>
          <li>Click "Save" to validate your email</li>
          <li>Refresh this page after successful validation</li>
        </ul>
        
        <BodyText hasGreyText>
          If you continue to experience issues, please contact support@prospectorpro.co.uk
        </BodyText>
      </div>
    </div>
  )
}

export default LoginFailedBlock
